import React, { useEffect } from 'react'
import AboutFirst from '../Components/About/AboutFirst'
import Mission from '../Components/About/Mission'
import FeaturedGames from '../Components/About/FeaturesGame'
import AboutHeroSection from '../Components/About/AboutHerosection'
import { useSEO } from './Seo'
import { Helmet } from 'react-helmet'

const About = () => {

useSEO({
    title: "About Game Zone Hub | Play Free Online Games",
    description:
      "Learn about Game Zone Hub, your ultimate destination to play free online games. Discover our mission to provide the best online games with no downloads required.",
    keywords:
      "about game zone hub, play free online games, online games, play free online, free browser games, gaming platform",
    canonical: "https://www.gamezonehub.in/about",
    ogTitle: "About Game Zone Hub - Play Free Online Games",
    ogDescription: "Discover our mission to provide the best free online games instantly. No downloads, just play!",
  });


const STORAGE_KEY = "gameListPage"

useEffect(()=>{
  localStorage.setItem(STORAGE_KEY, String(1))
  window.scrollTo({top:"0"})
},[])

const schemaData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Game Zone Hub",
    "url": "https://www.gamezonehub.in/",
    "description": "Game Zone Hub is a leading platform to play free online games. We offer the best browser games instantly without any downloads.",
    "foundingDate": "2024", 
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "customer support",
      "email": "dhruvinsavani9313@gmail.com" 
    },
  };

  return (
    <div>
      <Helmet>
        {schemaData && (
          <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }} />
        )}
      </Helmet>

      <AboutFirst/>
      <AboutHeroSection/>
      
          
        <Mission/>
      <FeaturedGames/>
    </div>
  )
}

export default About
